import React from "react";
import PropTypes from "prop-types";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import ProjectLinks from "./ProjectLinks";

const WebRealisationCard = ({ data }) => {
  const technologiesArray = data.technos.split(", ");
  return (
    <div className="flex flex-col rounded-lg bg-white border border-gray-300 shadow-md hover:shadow-lg transition-shadow duration-300 max-w-md">
      <figure className="w-full h-48 flex-shrink-0">
        {data.link && data.link !== "" ? (
          <a
            href={data.link}
            target="_blank"
            rel="noreferrer noopener"
            title="Voir le site"
            className="block w-full h-48">
            <img
              alt={data.techno}
              src={data.src}
              className="w-full h-48 object-cover hover:opacity-60 transition duration-300 ease-in-out rounded-t-lg"
            />
          </a>
        ) : (
          <div className="w-full h-48">
            <Zoom zoomImg={{ alt: data.techno, src: data.src }}>
              <img
                alt={data.techno}
                src={data.src}
                className="w-full h-48 object-cover cursor-zoom-in rounded-t-lg"
              />
            </Zoom>
          </div>
        )}
      </figure>
      <div className="card-body p-5 flex flex-col justify-between flex-grow">
        <div className="flex-grow">
          <h3 className="card-title font-bold text-xl">
            {data.titre} - {data.techno}{" "}
            <span className="badge badge-outline">{data.annee}</span>
          </h3>
          <p className="mb-4">{data.description}</p>
          <p className="mb-4">
            <span className="font-bold">Objectif: </span>
            {data.objectif}
          </p>
          <p className="mb-4">
            <span className="font-bold">Technique: </span>
            {data.technique}
          </p>
          <div className="mb-4">
            <ul className="flex flex-wrap technos">
              {technologiesArray.map((tech) => (
                <li key={tech} className="mr-2 mb-2 badge p-3">
                  {tech}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="card-actions justify-end mt-auto">
          <ProjectLinks git={data.git} link={data.link} />
        </div>
      </div>
    </div>
  );
};

WebRealisationCard.propTypes = {
  data: PropTypes.shape({
    titre: PropTypes.string.isRequired,
    techno: PropTypes.string.isRequired,
    annee: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    objectif: PropTypes.string.isRequired,
    technique: PropTypes.string.isRequired,
    technos: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    link: PropTypes.string,
    git: PropTypes.string,
  }).isRequired,
};

export default WebRealisationCard;
